import Input from './Input';
import Stack from './Stack';
import { US_STATES, isKnownStateCode } from '../utils/usStates';
import { isZipValid } from '../utils/addressValidation';

function AddressForm({ address, handleChange }) {
  const zipEntered = Boolean((address.zip || '').trim());
  const zipInvalid = zipEntered && !isZipValid(address.zip);

  // A legacy address (saved before this dropdown existed) may hold a value
  // that isn't one of our codes. Render it as its own option so the select
  // shows the real stored value instead of silently defaulting to the first
  // option in the list.
  const hasUnknownState = Boolean(address.state) && !isKnownStateCode(address.state);

  return (
    <Stack width="full" justify="center" align="center" gap="4">
      <Input
        name="street"
        placeholder="Street Address"
        value={address.street}
        onChange={handleChange}
      />
      <div className="flex sm:flex-row flex-col gap-4 w-full">
        <Input
          name="city"
          placeholder="City"
          value={address.city}
          onChange={handleChange}
        />
        <div className="text-black flex flex-col items-start justify-start w-full gap-1">
          <select
            name="state"
            value={address.state}
            onChange={handleChange}
            className="p-2 w-full text-black border border-gray-300 rounded-md focus:border-yellow-300 focus:outline-none focus:ring-0 bg-white"
          >
            <option value="" disabled>State</option>
            {hasUnknownState && (
              <option value={address.state}>{address.state} (please update)</option>
            )}
            {US_STATES.map(({ code, name }) => (
              <option key={code} value={code}>{name} ({code})</option>
            ))}
          </select>
          {hasUnknownState && (
            <p className="px-2 text-xs text-red-500">This address predates the state dropdown — please pick the correct state.</p>
          )}
        </div>
        <div className="text-black flex flex-col items-start justify-start w-full gap-1">
          <Input
            name="zip"
            placeholder="Zip Code"
            value={address.zip}
            onChange={handleChange}
          />
          {zipInvalid && (
            <p className="px-2 text-xs text-red-500">Enter a valid zip code (e.g. 84003)</p>
          )}
        </div>
      </div>
    </Stack>
  );
}

export default AddressForm;
